import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AdminDashboardComponent } from './admin/admin-dashboard.component';
import { MarketingBannerComponent } from './admin/marketing-banner/marketing-banner.component';
import { NotificationBannerComponent } from './admin/notification-banner/notification-banner.component';
import { PartnerEmailAccessComponent } from './admin/partner-email-allow-list/partner-email-allow-list.component';
import { PartnerWorkshopAccessComponent } from './admin/partner-workshop-access/partner-workshop-access.component';
import { PrivateWorkshopAccessComponent } from './admin/private-workshop-access-lists/private-workshop-access-lists.component';
import { AgreementPartnerDetailsComponent } from './admin/program-agreement-partner-details/agreement-partner-details.component';
import { AdvisorIncentivesComponent } from './advisor-incentives/advisor-incentives.component';
import { MSAIDownloadCsvComponent } from './advisor-incentives/download-csv/download-csv.component';
import { BatchEmailComponent } from './batch-email/batch-email.component';
import { CsiEditMilestone2PaymentBatchComponent } from './csi-payment-schedule/csi-edit-milestone2-payment-batch/csi-edit-milestone2-payment-batch.component';
import { CsiNewPaymentBatchMilestone2Component } from './csi-payment-schedule/csi-new-payment-batch-milestone2/csi-new-payment-batch-milestone2.component';
import { CustomerUsageComponent } from './customer-usage/customer-usage.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EventEditPaymentBatchMilestone2Component } from './events-payment-schedule/event-edit-payment-batch-milestone2/event-edit-payment-batch-milestone2.component';
import { EventEditPaymentBatchComponent } from './events-payment-schedule/event-edit-payment-batch/event-edit-payment-batch.component';
import { EventNewPaymentBatchMilestone2Component } from './events-payment-schedule/event-new-payment-batch-milestone2/event-new-payment-batch-milestone2.component';
import { EventNewPaymentBatchComponent } from './events-payment-schedule/event-new-payment-batch/event-new-payment-batch.component';
import { EventsPaymentScheduleComponent } from './events-payment-schedule/events-payment-schedule.component';
import { HomeComponent } from './home/home.component';
import { EventsDashboardComponent } from './mcap-events/events-dashboard/events-dashboard.component';
import { MrppDashboardComponent } from './mrpp/mrpp-dashboard/mrpp-dashboard.component';
import { AccessDeniedComponent } from './pages/access-denied.component';
import { ErrorComponent } from './pages/error.component';
import { NotFoundComponent } from './pages/not-found.component';
import { PartnerDashboardComponent } from './partner-dashboard/partner-dashboard.component';
import { PaymentProfilesComponent } from './payment-profiles/payment-profiles.component';
import { EditMilestine2PaymentBatchComponent } from './payment-schedule/edit-milestone2-payment-batch/edit-milestone2-payment-batch.component';
import { EditMsaipMilestine2PaymentBatchComponent } from './payment-schedule/edit-msaip-payment-batch-milestone2/edit-msaip-milestone2-payment-batch.component';
import { EditPaymentBatchComponent } from './payment-schedule/edit-payment-batch/edit-payment-batch.component';
import { MsaipPaymentScheduleMilestone2Component } from './payment-schedule/msaip-payment-schedule-milestone2/msaip-payment-schedule-milestone2.component';
import { NewMsaipPaymentBatchMilestone2Component } from './payment-schedule/new-msaip-payment-batch-milestone2/new-msaip-payment-batch-milestone2.component';
import { NewPaymentBatchMilestone2Component } from './payment-schedule/new-payment-batch-milestone2/new-payment-batch-milestone2.component';
import { NewPaymentBatchComponent } from './payment-schedule/new-payment-batch/new-payment-batch.component';
import { PaymentScheduleComponent } from './payment-schedule/payment-schedule.component';
import { DownloadCsvComponent } from './shared/download-csv/download-csv.component';
import { SIDownloadCsvComponent } from './shared/si-download-csv/si-download-csv.component';
import { SpecialInvestmentsComponent } from './special-investments/special-investments.component';
import { ExportAllEngagementComponent } from './mrpp/export-all-engagement/export-all-engagement.component';
import { EventDownloadCsvComponent } from './mcap-events/components/download-csv/download-csv.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        canActivate: [MsalGuard],
        component: DashboardComponent
      },
      {
        path: 'dashboard',
        canActivate: [MsalGuard],
        component: DashboardComponent,
        data: {
          breadcrumb: {
            label: 'Dashboard'
          }
        }
      },
      {
        path: 'home',
        canActivate: [MsalGuard],
        component: HomeComponent,
        data: {
          breadcrumb: {
            label: 'Engagement Dashboard'
          }
        }
      },
      {
        path: 'partner-dashboard',
        canActivate: [MsalGuard],
        component: PartnerDashboardComponent,
        data: {
          breadcrumb: {
            label: 'Partner Dashboard'
          }
        }
      },
      {
        path: 'customer-usage',
        canActivate: [MsalGuard],
        component: CustomerUsageComponent,
        data: {
          breadcrumb: {
            label: 'Customer Usage'
          }
        }
      },
      {
        path: 'download-csv',
        canActivate: [MsalGuard],
        component: DownloadCsvComponent,
        data: {
          breadcrumb: {
            label: 'Download Report'
          }
        }
      },
      {
        path: 'payment-schedule',
        canActivate: [MsalGuard],
        component: PaymentScheduleComponent,
        data: {
          breadcrumb: {
            label: 'Payment Schedule'
          }
        }
      },
      {
        path: 'new-payment-batch',
        canActivate: [MsalGuard],
        component: NewPaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Create A New Payment Batch'
          }
        }
      },
      {
        path: 'milestone1-edit-payment-batch/:pbName',
        canActivate: [MsalGuard],
        component: EditPaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Edit Payment Batch'
          }
        }
      },
      {
        path: 'new-payment-batch-milestone2',
        canActivate: [MsalGuard],
        component: NewPaymentBatchMilestone2Component,
        data: {
          breadcrumb: {
            label: 'Create A New Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'milestone2-edit-payment-batch/:pbName',
        canActivate: [MsalGuard],
        component: EditMilestine2PaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Edit Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'csi-milestone2-edit-payment-batch/:pbName',
        canActivate: [MsalGuard],
        component: CsiEditMilestone2PaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Edit CSI Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'csi-new-payment-batch-milestone2',
        canActivate: [MsalGuard],
        component: CsiNewPaymentBatchMilestone2Component,
        data: {
          breadcrumb: {
            label: 'Create A New CSI Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'msaip-milestone2-edit-payment-batch/:pbName',
        canActivate: [MsalGuard],
        component: EditMsaipMilestine2PaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Edit A MSAIP Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'admin',
        canActivate: [MsalGuard],
        component: AdminDashboardComponent,
        data: {
          breadcrumb: {
            label: 'Admin'
          }
        }
      },
      {
        path: 'private-workshop-access-lists',
        canActivate: [MsalGuard],
        component: PrivateWorkshopAccessComponent,
        data: {
          breadcrumb: {
            label: 'Private Workshop Access Lists'
          }
        }
      },
      {
        path: 'notification-banner',
        canActivate: [MsalGuard],
        component: NotificationBannerComponent,
        data: {
          breadcrumb: {
            label: 'Notification Banner Configuration'
          }
        }
      },
      {
        path: 'marketing-banner',
        canActivate: [MsalGuard],
        component: MarketingBannerComponent,
        data: {
          breadcrumb: {
            label: 'Marketing Manager Configuration'
          }
        }
      },
      {
        path: 'partner-workshop-access-lists',
        canActivate: [MsalGuard],
        component: PartnerWorkshopAccessComponent,
        data: {
          breadcrumb: {
            label: 'MCAP Partner Workshop Access Lists'
          }
        }
      },
      {
        path: 'partner-email-allow-lists',
        canActivate: [MsalGuard],
        component: PartnerEmailAccessComponent,
        data: {
          breadcrumb: {
            label: 'Partner Email Allow List'
          }
        }
      },
      {
        path: 'program-agreement-partner-details',
        canActivate: [MsalGuard],
        component: AgreementPartnerDetailsComponent,
        data: {
          breadcrumb: {
            label: 'Program Agreement Partner Details'
          }
        }
      },
      {
        path: 'batch-email',
        canActivate: [MsalGuard],
        component: BatchEmailComponent,
        data: {
          breadcrumb: {
            label: 'Batch Email'
          }
        }
      },
      {
        path: 'special-investments',
        canActivate: [MsalGuard],
        component: SpecialInvestmentsComponent,
        data: {
          breadcrumb: {
            label: 'Special Investments'
          }
        }
      },
      {
        path: 'events',
        canActivate: [MsalGuard],
        component: EventsDashboardComponent,

        data: {
          breadcrumb: {
            label: 'Events Dashboard'
          }
        }
      },
      {
        path: 'events/download-csv',
        canActivate: [MsalGuard],
        component: EventDownloadCsvComponent,
        data: {
          breadcrumb: {
            label: 'Events Dashboard'
          }
        }
      },
      // {
      //   path: 'payment-requests-sps',
      //   canActivate: [MsalGuard],
      //   component: PaymentRequestsComponent
      // },
      {
        path: 'mrpp',
        canActivate: [MsalGuard],
        component: MrppDashboardComponent,
        data: {
          breadcrumb: {
            label: 'MRPP Dashboard'
          }
        }
      },
      {
        path: 'mrpp/download-csv',
        canActivate: [MsalGuard],
        component: ExportAllEngagementComponent,
        data: {
          breadcrumb: {
            label: 'MRPP Dashboard'
          }
        }
      },
      {
        path: 'events-edit-payment-batch/:pbName',
        canActivate: [MsalGuard],
        component: EventEditPaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Edit Event Payment Batch'
          }
        }
      },
      {
        path: 'events-new-payment-batch',
        canActivate: [MsalGuard],
        component: EventNewPaymentBatchComponent,
        data: {
          breadcrumb: {
            label: 'Create A New Payment Batch'
          }
        }
      },
      {
        path: 'si-download-csv',
        canActivate: [MsalGuard],
        component: SIDownloadCsvComponent,
        data: {
          breadcrumb: {
            label: 'Download Report'
          }
        }
      },
      {
        path: 'advisor-incentives',
        canActivate: [MsalGuard],
        component: AdvisorIncentivesComponent,
        data: {
          breadcrumb: {
            label: 'Advisor Incentives'
          }
        }
      },
      {
        path: 'msai-download-csv',
        canActivate: [MsalGuard],
        component: MSAIDownloadCsvComponent,
        data: {
          breadcrumb: {
            label: 'Download Report'
          }
        }
      },
      {
        path: 'msaip-milestone2-payment-schedule',
        canActivate: [MsalGuard],
        component: MsaipPaymentScheduleMilestone2Component,
        data: {
          breadcrumb: {
            label: 'MSAIP Milestone 2 Payment Schedule'
          }
        }
      },
      {
        path: 'new-msaip-payment-batch-milestone2',
        canActivate: [MsalGuard],
        component: NewMsaipPaymentBatchMilestone2Component,
        data: {
          breadcrumb: {
            label: 'Create A New MSAIP Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'payment-profiles',
        canActivate: [MsalGuard],
        component: PaymentProfilesComponent,
        data: {
          breadcrumb: {
            label: 'Payment Profiles'
          }
        }
      },
      {
        path: 'events-payment-schedule',
        canActivate: [MsalGuard],
        component: EventsPaymentScheduleComponent,
        data: {
          breadcrumb: {
            label: 'Events Payment Schedule'
          }
        }
      },
      {
        path: 'event-new-payment-batch-milestone2',
        canActivate: [MsalGuard],
        component: EventNewPaymentBatchMilestone2Component,
        data: {
          breadcrumb: {
            label: 'Create A New Milestone 2 Payment Batch'
          }
        }
      },
      {
        path: 'event-edit-payment-batch-milestone2/:pbName',
        canActivate: [MsalGuard],
        component: EventEditPaymentBatchMilestone2Component,
        data: {
          breadcrumb: {
            label: 'Edit Milestone 2 Payment Batch'
          }
        }
      }
    ]
  },
  { path: 'error', component: ErrorComponent },
  { path: 'accessdenied', component: AccessDeniedComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
